import { createCompositeStore as n } from "../__chunks/2CHYBBFH.js";
import { createStore as f } from "../__chunks/BCALMBPZ.js";
import { defaultValue as l } from "../__chunks/PBFD2E7P.js";
import { __objRest as m, __spreadProps as a, __spreadValues as e } from "../__chunks/3YLGPPWQ.js";
function V(i = {}) {
  var o = m(i, []), s;
  const t = (s = o.store) == null ? void 0 : s.getState(), r = n(a(e({}, o), {
    focusLoop: l(o.focusLoop, t == null ? void 0 : t.focusLoop, !0)
  })), p = a(e({}, r.getState()), {
    value: l(
      o.value,
      t == null ? void 0 : t.value,
      o.defaultValue,
      null
    )
  }), u = f(p, r, o.store);
  return a(e(e({}, r), u), {
    setValue: (c) => u.setState("value", c)
  });
}
export {
  V as createRadioStore
};
//# sourceMappingURL=radio-store.js.map
